import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal, FormInput, FormTextarea } from '../../components'
import { newGlossary, getGlossasryItem, updateGlossary } from '../../api'
import { back, replace } from '../../actions/nav-actions'
import { notify } from '../../utils'

class Form extends Component {
    constructor(props) {
        super(props)
        this.state = {
            name: '',
            key: '',
            tags: '',
            text: [],
            sources: [],
            modal_visible: true,
        }
        this.onRequest = this.onRequest.bind(this)
    }
    getParams() {
        return this.props.match.params || {};
    }
    componentDidMount() {
        this.getGlossaryItem()
    }
    getGlossaryItem = async () => {
        const params = this.getParams();
        if (!!params.id) {
            const glossary = await getGlossasryItem(this.props.user.token, params.id)
            if (!!glossary) {
                this.setState({ ...glossary, tags: (glossary.tags || []).join(',') })
            }
        }
    }
    onRequest(event) {
        if (event) event.preventDefault()
        let request = !!this.state._id ? updateGlossary : newGlossary
        request(this.props.user.token, {
            ...this.state
        }, this.state._id).then((item) => {
            this.props.replace(`/glossary/${item._id}`)
        }).catch(err => {
            notify('Error!', err.message, 'error')
        })
    }
    renderTags = () => {
        return (
            <React.Fragment>
                <br /><br />
                <b>Tags separated by comma</b><br />
                <FormInput
                    onChange={(tags) => {
                        this.setState({ tags })
                    }}
                    required
                    value={this.state.tags}
                    placeholder="Tags" />
            </React.Fragment>
        )
    }
    renderTexts = () => {
        return (
            <React.Fragment>
                <b>Texts</b><br />
                {(!this.state.text || this.state.text.length == 0) && (
                    <div>
                        <span>You need to add texts to start to write.</span>
                    </div>
                )}
                {((this.state.text && this.state.text.length > 0) && (
                    this.state.text.map((t, index) => {
                        return (
                            <React.Fragment>
                                <FormTextarea
                                    onChange={(text_updated) => {
                                        let { text } = this.state
                                        text[index] = text_updated
                                        this.setState({ text })
                                    }}
                                    placeholder="Text Paragraph"
                                    value={t} key={index}
                                    required />
                                <a href="#" onClick={(event) => {
                                    event.preventDefault()
                                    let text = this.state.text.filter((s, i) => i != index)
                                    this.setState({ text })
                                }} style={{
                                    position: 'relative', top: '-12px',
                                    color: 'red', display: 'block'
                                }}>- Remove Paragraph</a>
                            </React.Fragment>
                        )
                    })
                ))}
                <a href="#" onClick={(event) => {
                    event.preventDefault()
                    let { text } = this.state
                    text.push('')
                    this.setState({ text })
                }}>+ Add Text</a>
            </React.Fragment>
        )
    }
    renderSources = () => {
        return (
            <React.Fragment>
                <br /><br />
                <b>Sources</b><br />
                {(!this.state.sources || this.state.sources.length == 0) && (
                    <div>
                        <span>You dont have sources.</span>
                    </div>
                )}
                {((this.state.sources && this.state.sources.length > 0) && (
                    this.state.sources.map((t, index) => {
                        return (
                            <React.Fragment>
                                <FormInput
                                    onChange={(text_updated) => {
                                        let { sources } = this.state
                                        sources[index] = text_updated
                                        this.setState({ sources })
                                    }}
                                    placeholder="Source"
                                    value={t} key={index}
                                    required />
                                <a href="#" onClick={(event) => {
                                    event.preventDefault()
                                    let sources = this.state.sources.filter((s, i) => i != index)
                                    this.setState({ sources })
                                }} style={{
                                    position: 'relative', top: '-12px',
                                    color: 'red', display: 'block'
                                }}>- Remove Source</a>
                            </React.Fragment>
                        )
                    })
                ))}
                <a href="#" onClick={(event) => {
                    event.preventDefault()
                    let { sources } = this.state
                    sources.push('')
                    this.setState({ sources })
                }}>+ Add Source</a>
            </React.Fragment>
        )
    }
    render() {
        return (
            <Modal
                visible={this.state.modal_visible}
                onClose={() => this.setState({ modal_visible: false }, this.props.back)}
                title={!!this.state._id ? 'Update Glossary Item' : 'New Glossary Item'}
                action_text={!!this.state._id ? "UPDATE GLOSSARY ITEM" : "ADD GLOSSARY ITEM"}
                style={{ maxHeight: '350px', overflow: 'scroll' }}
                onActionClick={this.onRequest}>
                <form onSubmit={this.onRequest}>
                    <FormInput
                        onChange={(name) => {
                            this.setState({ name })
                        }}
                        required
                        value={this.state.name}
                        placeholder="Name" />
                    <FormInput
                        onChange={(key) => {
                            this.setState({ key })
                        }}
                        required
                        value={this.state.key}
                        placeholder="Key ID" />
                    {this.renderTexts()}
                    {this.renderSources()}
                    {this.renderTags()}
                </form>
            </Modal>
        )
    }
}

const mapStateToProps = state => ({ user: state.authReducer.user })

const mapDispatchToProps = dispatch => ({
    back() {
        dispatch(back())
    },
    replace(routeName) {
        dispatch(replace(routeName))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Form)


// WEBPACK FOOTER //
// ./src/routers/Glossary/Form.js